var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedAssetLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.4C10 1.63029 9.93025 1.86069 9.79074 2.03619L4.07645 9.23619C3.9375 9.41281 3.75446 9.5 3.57143 9.5C3.38839 9.5 3.2058 9.41211 3.06652 9.23633L0.209375 5.63633C0.0698661 5.46125 0 5.23063 0 5C0 4.48588 0.333705 4.1 0.714286 4.1C0.897054 4.1 1.07991 4.18789 1.2192 4.36367L3.57143 7.32875L8.78125 0.764375C8.91964 0.588031 9.10268 0.5 9.28571 0.5C9.66741 0.5 10 0.885313 10 1.4Z",
    fill: "#10A37F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedAssetLine);
export default __webpack_public_path__ + "static/media/checkedAssetLine.1609d4b09891d8113895b6297d06323c.svg";
export { ForwardRef as ReactComponent };